import React from 'react'
import { FaGithub, FaFacebook, FaLinkedin, } from 'react-icons/fa'

export const links = [

  {
    id: 1,
    url: '/',
    text: 'about',
  },
 
  {
    id: 2,
    url: '/projects',
    text: 'projects',
  },
  {
    id: 3,
    url: '/experience',
    text: 'experience',
  },
  {
    id: 4,
    url: '/contact',
    text: 'contact',
  },
]

export const social = [
  {
    id: 1,
    url: 'https://www.facebook.com/Ennkaos/',
    icon: <FaFacebook />,
    name:"Facebook"
  },
  {
    id: 2,
    url: 'https://github.com/ennkaos',
    icon: <FaGithub />,
    name:"GitHub"
  },
  {
    id: 3,
    url: 'https://www.linkedin.com/in/bucur-alexandru-932970205/',
    icon: <FaLinkedin />,
    name:"Linkedin"
  },
]

export const images = [
  {
    id: 1,
    src:"./16.jpg"
  },
  {
    id: 2,
    src:"./1.png"
  },
  {
    id: 3,
    src:"./2.png"
  },
  {
    id: 4,
    src:"./3.png"
  },
  {
    id: 5,
    src:"./4.png"
  },
  {
    id: 6,
    src:"./5.png"
  },
  {
    id: 7,
    src:"./6.png"
  },
  {
    id: 8,
    src:"./7.png"
  },
  {
    id: 9,
    src:"./8.png"
  },
  {
    id: 10,
    src:"./9.png"
  },
  {
    id: 11,
    src:"./10.png"
  },
  {
    id: 12,
    src:"./11.png"
  },
  {
    id: 13,
    src:"./12.png"
  },
  {
    id: 14,
    src:"./13.png"
  },
  {
    id: 15,
    src:"./1.png"
  },
  {
    id: 16,
    src:"./14.png"
  },
  {
    id: 17,
    src:"./16.png"
  },
  {
    id: 18,
    src:"./16.jpg"
  },
  {
    id: 19,
    src:"./16.jpg"
  },
  {
    id: 20,
    src:"./16.jpg"
  },
  {
    id: 21,
    src:"./16.jpg"
  },
  {
    id: 22,
    src:"./16.jpg"
  },
  {
    id: 23,
    src:"./16.jpg"
  },
  {
    id: 24,
    src:"./16.png"
  },
  {
    id: 25,
    src:"./16.jpg"
  },
  {
    id: 26,
    src:"./16.jpg"
  },
  {
    id: 27,
    src:"./16.jpg"
  },
  {
    id: 28,
    src:"./16.jpg"
  },
  {
    id: 29,
    src:"./16.jpg"
  },
  {
    id: 30,
    src:"./16.jpg"
  },
  

 
]
export const jobs = [
  {
    id: 1,
    image:
      './job1.jpg',
    name: 'Raiffeisen Bank',
    title: 'Telebanking Operator',
    quote:
      "There I've worked as a telebanking operator and I helped solving client issues like : Credit loans and bills. There I've learned how to communicate as efficient as I can and also to work in a corporation enviroment. I pulled out some hard work when i was working there. ",
      time:"10 June 2019 - 12 December 2019",
    },
  {
    id: 2,
    image:
      './job2.png',
    name: 'Ipsos ',
    title: 'Script Writter',
    quote:
      "Ipsos is a marketing research company that has a very big platform with a huge database of clients. I worked as a Script Writter ,coding logic for the dynamic web questionnaires . I really could say that I gained a lot of experience using HTML ,CSS and Vanilla JavaScript but the main focus was on the IBM programming Language called Dimensions",
      time:"1 March 2020 - 1 February 2021",
    },
  {
    id: 3,
    image:
      './job3.png',
    name: 'People Power',
    title: 'Software developer',
    quote:
      'For a big period of time the position that i occupied at this company was as an Intern . The main programming language used was C# and also the technologies around ASP.NET. There i developed the work etic regarding tasks and deadlines . I learned what OOP really is and understood the concepts around it',
  
    time:"10 July 2020 - 10 August 2020",
    },
  {
    id: 4,
    image:
      './job4.jpg',
    name: 'Mia Sicilia',
    title: 'Front End Web Developer',
    quote:
      "This is the present job that I have . I am a front web developer at Mia Sicilia .The main focus of the activity of the company is tourism . The company has a big platform for tourist where they can make appointments and all kind of touristic services . My main activity is creating the fron end for web pages from different clients . The accent is put on quality and aspect.  ",
    time:"15 April 2021- Present",
    },
];

export const ratings = [
  {
    id: 1,
    name:'HTML',
    value:85,
    
    
    },
    {
      id: 2,
      name:'CSS',
      value:85,
      
      
    },
    {
    id: 3,
    name:'JavaScript',
    value:60,
        
        
    },
    {
    id: 4,
    name:'React',
    value:60,
          
          
    },
    {
    id: 5,
    name:'C#',
    value:50,
            
            
    },
    {
    id: 6,
    name:'Node Js',
    value:40,
              
              
    },
    {
    id: 7,
    name:'Mongo DB',
    value:40,
                
                
    },
    {
    id: 8,
    name:'SQl ',
    value:30,
                
                
    },
            
];

export const questions = [
  {
    id: 1,
    title: 'How you can get in touch with me?',
    info:
      `You can email me at   bucur.alexandru0106@gmail.com   or contact me on the phone at  ..... +39 327 067 1906`,
  },
  {
    id: 2,
    title: 'How do I work?',
    info:
      'I can work from everywhere . I can travel as well and I will always be happy to engage into a new task next to a great team.',
  },
  {
    id: 3,
    title: 'Where I live Now?',
    info:
      "Now I am currently living in Italy/Firenze . But don't worry I can work both remotely and at the office.",
  },
  {
    id: 4,
    title: 'What I am hopping to achieve ?',
    info:
      "I always want to improve and become better at what I am doying . Evolution and learning is a big part of being a programmer and I think that is the fact that keeps my passion alive.  ",
  },
  {
    id: 5,
    title: 'What I can do exactly?',
    info:
      "I can create dynamic web applications using React JS, Axios ,Redux , HTML , CSS even Node JS and Express. I can also work with MongoDB and SQL but honestly I prefer NO SQL anyday of the week. ",
  },
]